export const HEADING_TYPOGRAPHY_STYLES = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] as const;

export const BODY_TYPOGRAPHY_STYLES = [
  'bodyLargeDMSans',
  'bodyLargeSpaceGrotesk',
  'bodyDMSans',
  'bodySpaceGrotesk',
  'bodySmallDMSans',
  'bodySmallSpaceGrotesk',
  'bodyExtraSmallDMSans',
  'bodyExtraSmallSpaceGrotesk',
  'bodyExtraExtraSmallDMSans',
  'bodyExtraExtraSmallSpaceGrotesk',
] as const;

export const TYPOGRAPHY_STYLES = [...HEADING_TYPOGRAPHY_STYLES, ...BODY_TYPOGRAPHY_STYLES] as const;

export type TypographyStyle = (typeof TYPOGRAPHY_STYLES)[number];

export const TYPOGRAPHY_STYLE_LABELS: Record<TypographyStyle, string> = {
  h1: 'H1',
  h2: 'H2',
  h3: 'H3',
  h4: 'H4',
  h5: 'H5',
  h6: 'Title',
  bodyLargeDMSans: 'Body Large (DM Sans)',
  bodyLargeSpaceGrotesk: 'Body Large (Space Grotesk)',
  bodyDMSans: 'Body (DM Sans)',
  bodySpaceGrotesk: 'Body (Space Grotesk)',
  bodySmallDMSans: 'Body Small (DM Sans)',
  bodySmallSpaceGrotesk: 'Body Small (Space Grotesk)',
  bodyExtraSmallDMSans: 'Body Extra Small (DM Sans)',
  bodyExtraSmallSpaceGrotesk: 'Body Extra Small (Space Grotesk)',
  bodyExtraExtraSmallDMSans: 'Body Extra Extra Small (DM Sans)',
  bodyExtraExtraSmallSpaceGrotesk: 'Body Extra Extra Small (Space Grotesk)',
};
